import { NavMarker } from 'react-rhumb';
import LoginForm from './LoginForm';
import SignupLink from '../shared/SignupLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginLanding = ({
  allowFbSignup,
  signupParams,
  loginRedirectUrl,
  loginSubmit,
  googleLoginClick,
  ssoLoginClick,
  isInvalidTokenAlertVisible,
  hideSignupLink,
  pageId
}) => /*#__PURE__*/_jsx(NavMarker, {
  name: "LOGIN_LOAD",
  children: /*#__PURE__*/_jsxs("div", {
    className: "auth-box marketing-box",
    children: [!hideSignupLink && /*#__PURE__*/_jsx(SignupLink, {
      isFbSignin: allowFbSignup
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | string[]' is not assignable to type... Remove this comment to see the full error message
      ,

      signupParams: signupParams,
      loginRedirectUrlQueryParam: loginRedirectUrl,
      pageId: pageId
    }), /*#__PURE__*/_jsx(LoginForm
    // @ts-expect-error ts-migrate - clash between functional and class components
    , {
      onLoginSubmit: loginSubmit,
      onGoogleLoginClick: googleLoginClick,
      onSsoLoginClick: ssoLoginClick,
      isInvalidTokenAlertVisible: isInvalidTokenAlertVisible,
      loginRedirectUrl: loginRedirectUrl
    })]
  })
});
export default LoginLanding;